import React from 'react';
import PropTypes from 'prop-types';

const onChange = (value, callback) => {
    const valueReplaced = value.replace(/\s/g,'');
    if (!isNaN(valueReplaced)) {
        callback(valueReplaced)
    }
}

const Phone = ({valueNumber, onChangeNumber = () => {}, isError = false, errorMessage = 'Enter valid phone number'}) => (
    <div id="row_phone1" className="country__item">
        <div className="personal-info__lbl">Contact phone:*</div>
        <div className="personal-info__value">
            <div className="form__phone">
                <input id="phone1" name="phone1" type="hidden" />
                <input value={valueNumber}
                       onChange={(event) => {onChange(event.target.value, onChangeNumber)}}
                       id="phone1_number"
                       name="phone1_number"
                       type="text"
                       size="21"
                       maxLength="17"
                       placeholder="number"
                       className={`${isError ? `form-error` : ``}`}/>
            </div>
            {isError &&
                <div className="validation_error err-popup" id="error_phone">
                    {errorMessage}
                </div>
            }
        </div>
    </div>
)

Phone.propTypes = {
    valueNumber: PropTypes.string,
    onChangeNumber: PropTypes.func,
    isError: PropTypes.bool,
    errorMessage: PropTypes.string,
};

export default Phone
